import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'isInfiniteDate',
    standalone: false
})
export class IsInfiniteDatePipe implements PipeTransform {

  readonly infinityDate = new Date('9999-12-31T21:59:59.999')

  transform(value: Date | null | undefined): boolean {
    if (!value) return false
    return value >= this.infinityDate;
  }

}
